import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { HomepageContentModel } from './models/homepage.model';
import { HomepageContentResponse } from './models/homepage-response.model';

@Injectable({
  providedIn: 'root',
})
export class HomeContentService extends BaseGQLService<HomepageContentResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: HomepageContentModel,
        clientName: 'HomeContentService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryHomepageContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState
    );
  }


}


